import { createFileRoute, Outlet, redirect, Link, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { useAuth } from '@/auth/use-auth';
import { Button } from '@/components/ui/button';
import { StoreProvider } from '@/lib/store-context';
import { StoreSelector } from '@/components/store-selector';

const AppSearch = z.object({
  storeCode: z.string().regex(/^[A-Za-z0-9]{1,6}$/).optional(),
});

export const Route = createFileRoute('/_app')({
  validateSearch: AppSearch,
  beforeLoad: async ({ context }) => {
    const u = (context as any).user;
    if (!u) throw redirect({ to: '/login' });
  },
  component: AppLayout,
});

function AppLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (!user) return null;
  return (
    <StoreProvider>
      <div className="flex min-h-screen flex-col">
        <header className="flex flex-wrap items-center justify-between gap-3 border-b px-4 py-3">
          <div className="flex items-center gap-6">
            <span className="font-semibold">DALEEP NS</span>
            <nav className="flex flex-wrap gap-4 text-sm text-muted-foreground">
              <Link to="/" className="hover:text-foreground" activeProps={{ className: 'text-foreground' }}>Dashboard</Link>
              <Link to="/sales/dashboard" className="hover:text-foreground" activeProps={{ className: 'text-foreground' }}>Sales</Link>
              <Link to="/purchases" className="hover:text-foreground" activeProps={{ className: 'text-foreground' }}>Purchases</Link>
              <Link to="/inventory" className="hover:text-foreground" activeProps={{ className: 'text-foreground' }}>Inventory</Link>
              <Link to="/hr" className="hover:text-foreground" activeProps={{ className: 'text-foreground' }}>HR</Link>
              <Link to="/masters" className="hover:text-foreground" activeProps={{ className: 'text-foreground' }}>Masters</Link>
              {user.role === 'admin' && (
                <Link to="/admin/users" className="hover:text-foreground" activeProps={{ className: 'text-foreground' }}>Users</Link>
              )}
            </nav>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <StoreSelector />
            <span className="text-muted-foreground">{user.username} · {user.role}</span>
            <Button variant="outline" size="sm" onClick={async () => { await logout(); await new Promise((r) => setTimeout(r, 0)); await nav({ to: '/login' }); }}>
              Sign out
            </Button>
          </div>
        </header>
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </StoreProvider>
  );
}
